export const TableColumnsServizi = ['Id', 'Descrizione', 'Categoria di accreditamento', 'Progressivo', 'Codice servizio', 'Stato', 'Azioni'];
